import * as React from "react";
import { useEffect, useState } from "react";

import "./menu.less";
import { MenuBox } from "./components/menu-box/menu-box";
import { ButtonModalViewCart } from "modules/shared/button-view-cart";
import { ButtonModalViewCategory } from "modules/shared/button-view-category";
import { ModalAddCart } from "./components/add-item/modal-add-cart";
import { useAppDispatch, useAppSelector } from "app.hook";
import { loadingLocationParams, selectSignIn, setLoading, showOrderGuestModal } from "states/global-value/global-value.slice";
import { IProductCategoryModel } from "states/menu/menu.models";
import { getProductCategories } from "states/menu/menu.api";
import { Categories } from "./components/categories/category";
import { shallowEqual, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import {
  selectedBranchShoppingCart,
  selectShoppingCart,
  showViewCartModal,
} from "states/shopping-cart/shopping-cart.slice";
import { scroller } from 'react-scroll';
import { formatMoney } from "shared/plugins/string-helper";
import { useHistory, useLocation } from "react-router-dom";
import { CHECKOUT_ROUTE } from "shared/constants/routes";
import { IconShoppingBag } from "themes";
import { RootState } from "app.store";
import { selectBranches, setBranchCookie } from "states/branch/branch.slice";
import { IBranchModel } from "states/branch/branch.models";
import { fetchBranchOrderPickupSetting, selectBranchOrderPickupSetting } from "states/branch-order-pickup-setting/order-pickup-setting.slice";
import { PromotionSlideModal } from "./components/promotion-slide/promotion-slide-modal";
import { MenuDescriptionModal } from "./components/menu-description-modal/menu-description-modal";
export interface IMenuProps {

}

export default function MenuPage(props: IMenuProps) {
  const [categories, setCategories] = useState<IProductCategoryModel[]>([]);
  const dispatch = useAppDispatch();
  const branches = useAppSelector(selectBranches, shallowEqual);
  const currentBranch = useAppSelector(
    (state: RootState) => state.shoppingCart.shoppingCart.branch,
    shallowEqual
  );
  const isLogged = useSelector(selectSignIn, shallowEqual);
  const location = useLocation();
  const history = useHistory();
  const currentShoppingCart = useAppSelector(selectShoppingCart, shallowEqual);

  const getCategories = async () => {
    dispatch(setLoading(true));
    try {
      if (currentBranch?.id) {
        let results = await getProductCategories(currentBranch?.id);
        setCategories(results.data);
        let cateId = new URLSearchParams(location.search).get("cateId");
        if (cateId && Number(cateId)) {
          scrollTo(`cate-${cateId}`);
        }
      } else {
        setCategories([]);
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };
  const orderSetting = useAppSelector(selectBranchOrderPickupSetting, shallowEqual);
  useEffect(() => {
    let locationId = new URLSearchParams(location.search).get("locationId");
    if (locationId && Number(locationId) !== currentBranch.id) {
      let branch = [...branches].find((m) => m.id === Number(locationId));
      if (!branch) return;
      setBranchCookie(branch?.id?.toString() ?? "");
      dispatch(selectedBranchShoppingCart(branch ?? ({} as IBranchModel)));
      dispatch(loadingLocationParams());

    }
  }, [branches]);
  useEffect(() => {
    getCategories();
    dispatch(fetchBranchOrderPickupSetting());
    document.title = "Menu";

  }, [currentBranch]);
  const scrollTo = (element: string) => {
    scroller.scrollTo(element, {
      duration: 500,
      offset: -100,
      absolute: true,
      activeClass: "active",
      spy: true,
      delay: 0,
      smooth: "easeInQuad"
    })
  }

  return (
    <>
      {categories && (
        <section
          id="menu-page"
          className="flex space-x-4  md:space-x-0 sm:space-x-0 xs:space-x-0 "
        >
          <aside className="rounded-lg shadow-md p-2 side-menu w-1/3 visible md:hidden sm:hidden xs:hidden ">
            <h2 className="menu-header font-semibold text-xl mb-4 tracking-wider uppercase underline">
              Menu
            </h2>
            <Categories categories={categories} />
          </aside>
          <MenuBox categories={categories} />
        </section>
      )}
      <PromotionSlideModal currentBranch={currentBranch} />
      <ButtonModalViewCategory categories={categories} />
      <MenuDescriptionModal />
      <ModalAddCart />
      {orderSetting?.active && (
        !isMobile ? (
          <ButtonModalViewCart />
        ) : (
          <div className="view-cart-container-footer z-10 bg-white fixed left-0 bottom-0 w-full ">
            <div className="flex justify-between  px-4  content-center items-center">
              <button
                onClick={() => {
                  dispatch(showViewCartModal());
                }}
                className="icon btn--default relative"
              >
                <IconShoppingBag width={30} />
                <span className="bag rounded-full absolute bg--primary text-white">
                  {currentShoppingCart.items ?
                    currentShoppingCart.items.map(m => m.quantity).reduce((a, b) => a + b, 0)
                    : 0}
                </span>
              </button>
              <div className="total-container flex justify-between content-center items-center ">
                <div className="price font-semibold h3 mr-2">
                  {formatMoney(currentShoppingCart.subTotal, 2, ".", ",", "$")}
                </div>
                <button
                  onClick={() => {
                    if (!isLogged) {
                      dispatch(showOrderGuestModal());
                    } else {
                      history.push(CHECKOUT_ROUTE);
                    }
                  }}
                  className="button-container uppercase btn--default  px-4 py-4 rounded-none btn--primary inline"
                  aria-label="Checkout"
                >
                  Checkout
                </button>
              </div>
            </div>
          </div>
        )
      )}
      { }
    </>
  );
}
